module.exports = __webpack_public_path__ + "img/quadro-logo.f7c7b529.png";